var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bl-target-details-container" },
    [
      _c(
        "div",
        { staticClass: "p-6 space-y-4", attrs: { id: "target-details" } },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-4" },
            [
              _c("BlTextSubtitle1", { attrs: { text: "Details" } }),
              _vm._v(" "),
              !_vm.readonly
                ? _c("BlInputButton", {
                    attrs: { type: "outlined", dense: "", label: "Edit" },
                    on: { clicked: _vm.onOpenEditDetails }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "space-y-5" }, [
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Title" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "col-span-3 text-grey",
                  attrs: { text: _vm.target.name }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Curriculum" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex col-span-3 gap-2" },
                  [
                    _c("div", {
                      staticClass: "flex-shrink-0 rounded-full w-5 h-5 mt-0.5",
                      style: { backgroundColor: _vm.target.curriculum_color }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "text-grey",
                      attrs: { text: _vm.target.curriculum_name }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid items-center grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  attrs: { text: "Data collection method" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass: "col-span-3 text-grey",
                  attrs: { text: _vm.targetTypes[_vm.target.type] }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.target.type.includes("Prompting")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Format" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 capitalize text-grey",
                      attrs: { text: _vm.target.prompting_format }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.readonly
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Status" } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-span-3" }, [
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c("StatusChip", {
                            staticClass: "px-3 text-base",
                            attrs: { status: _vm.target.status }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.readonly
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Date introduced" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: {
                        text: _vm.displayDate(_vm.target.date_introduce)
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.readonly
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Date mastered" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.displayDate(_vm.target.date_mastered) }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid grid-cols-4 gap-x-4" },
              [
                _c("BlTextBody2", {
                  staticClass: "mt-0.5",
                  attrs: { text: "Description" }
                }),
                _vm._v(" "),
                _c("BlTextBody1", {
                  staticClass:
                    "col-span-3 text-base whitespace-pre-line text-grey",
                  attrs: { text: _vm.target.description || "-" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.target.type.includes("Percentage")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Goal" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.goal + "%" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Percentage")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Number of trial" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.number_of_trial }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Duration")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Goal time" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.goal_time }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Pir")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Goal" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.goal + "%" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Pir")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Interval" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.interval + " minutes" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Pir")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Duration" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.duration + " minutes" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Frequency")
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Goal" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: {
                        text: _vm.target.goal + " attempt(s) per session"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Prompting") &&
            _vm.target.prompting_format === "classic"
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "Goal and success metric" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-span-3 text-grey" },
                      [
                        _c("BlTextBody1", {
                          attrs: { text: "Achieve target with" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          staticClass: "font-bold",
                          attrs: { text: _vm.target.success_metric }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          attrs: { text: "prompt, minimum" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          staticClass: "font-bold",
                          attrs: { text: _vm.target.goal + " attempt(s)" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", { attrs: { text: "per session" } })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.target.type.includes("Prompting") &&
            _vm.target.prompting_format === "custom"
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Goal" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey",
                      attrs: { text: _vm.target.goal + "%" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.target.type.includes("Sbt") &&
            _vm.target.prompting_format !== "classic"
              ? _c(
                  "div",
                  { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                  [
                    _c("BlTextBody2", { attrs: { text: "Success metric" } }),
                    _vm._v(" "),
                    _c("BlTextBody1", {
                      staticClass: "col-span-3 text-grey capitalize-first",
                      attrs: { text: _vm.target.success_metric }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _vm.editDetailsOpened
        ? _c("EditTargetDetailsModal", {
            attrs: { target: _vm.target },
            on: {
              "close-modal": function($event) {
                _vm.editDetailsOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Prompting")
        ? _c("div", { attrs: { id: "prompt-selection" } }, [
            _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
            _vm._v(" "),
            _c("div", { staticClass: "grid grid-cols-2 gap-6 p-6" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4 mb-2" },
                  [
                    _c("BlTextSubtitle1", { attrs: { text: "Prompts" } }),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c("BlInputButton", {
                          attrs: { type: "outlined", dense: "", label: "Edit" },
                          on: { clicked: _vm.onOpenEditPromptSelection }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-4" },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "Personalize your card by selecting prompt buttons from the available options. Each symbol represents a specific prompt on the graph."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2 mb-2" },
                  [
                    _vm.target.prompting_format === "custom"
                      ? _c("BlTextSubtitle3", {
                          staticClass: "flex-shrink-0 w-20 text-slate-700",
                          attrs: { text: "Score (%)" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "flex-shrink-0 w-10 text-slate-700",
                      attrs: { text: "Code" }
                    }),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "flex-shrink-0 w-15 text-slate-700",
                      attrs: { text: "Symbol" }
                    }),
                    _vm._v(" "),
                    _c("BlTextSubtitle3", {
                      staticClass: "w-full text-slate-700",
                      attrs: { text: "Prompt name" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.target.prompting_format === "classic"
                  ? _c(
                      "div",
                      { staticClass: "flex flex-col gap-2" },
                      _vm._l(_vm.target.prompts, function(prompt) {
                        return _c("PromptingClientItem", {
                          key: prompt.id,
                          attrs: {
                            prompt: prompt,
                            format: _vm.target.prompting_format,
                            readOnly: ""
                          }
                        })
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.target.prompting_format === "custom"
                  ? _c(
                      "div",
                      { staticClass: "flex flex-col gap-2" },
                      _vm._l(_vm.groupedCustomPromptingPrompts, function(
                        group
                      ) {
                        return _c(
                          "div",
                          { key: group.score, staticClass: "flex gap-2" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex items-center justify-center flex-shrink-0 w-20 text-center border rounded bg-prim-100 border-prim-100"
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass:
                                    "font-semibold text-light-purple",
                                  attrs: { text: group.score }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col gap-2 truncate" },
                              _vm._l(group.prompts, function(prompt) {
                                return _c("PromptingClientItem", {
                                  key: prompt.id,
                                  attrs: {
                                    prompt: prompt,
                                    format: _vm.target.prompting_format,
                                    readOnly: ""
                                  }
                                })
                              }),
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center border bg-grey-100 border-grey-200 rounded-3xl"
                },
                [
                  _c("PromptPreview", {
                    style: { transform: "scale(0.625 , 0.625)" },
                    attrs: { prompts: _vm.target.prompts }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editPromptingOpened
        ? _c("EditPromptsModal", {
            attrs: {
              targetId: _vm.target.id,
              targetName: _vm.target.name,
              successMetric: _vm.target.success_metric,
              format: _vm.target.prompting_format,
              prompts: _vm.target.prompts
            },
            on: {
              "close-modal": function($event) {
                _vm.editPromptingOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Percentage")
        ? _c("div", { attrs: { id: "probing" } }, [
            _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
            _vm._v(" "),
            _c("div", { staticClass: "p-6 space-y-6" }, [
              _c(
                "div",
                { staticClass: "flex flex-col gap-2" },
                [
                  _c(
                    "div",
                    { staticClass: "flex items-center gap-4" },
                    [
                      _c("BlTextSubtitle1", { attrs: { text: "Probing" } }),
                      _vm._v(" "),
                      !_vm.readonly
                        ? _c("BlInputButton", {
                            attrs: {
                              type: "outlined",
                              dense: "",
                              label: "Edit"
                            },
                            on: { clicked: _vm.onOpenEditProbing }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Probing can be employed to assess a skill at various stages of your therapy. Activating probing gives you additional option to conduct probes during the session."
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.target.probing_enable
                ? _c("div", { staticClass: "space-y-5" }, [
                    _c(
                      "div",
                      { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "Minimum number of trials" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          staticClass: "col-span-3 text-grey",
                          attrs: { text: _vm.target.probing_number_of_trial }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "grid items-center grid-cols-4 gap-x-4" },
                      [
                        _c("BlTextBody2", {
                          attrs: { text: "Goal for probing" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody1", {
                          staticClass: "col-span-3 text-grey",
                          attrs: { text: "≥ " + _vm.target.probing_goal + "%" }
                        })
                      ],
                      1
                    )
                  ])
                : _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        staticClass: "italic",
                        attrs: {
                          text:
                            "Probing is inactive for this target, and no specific settings have been configured yet."
                        }
                      })
                    ],
                    1
                  )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editProbingOpened
        ? _c("EditProbingModal", {
            attrs: { target: _vm.target },
            on: {
              "close-modal": function($event) {
                _vm.editProbingOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.target.type.includes("Sbt")
        ? _c("div", { attrs: { id: "action-recommendation" } }, [
            _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
            _vm._v(" "),
            _c("div", { staticClass: "p-6 space-y-4" }, [
              _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "p-1 bg-orange-300",
                      style: { borderRadius: "4px" }
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "w-5 h-5",
                        attrs: { icon: "tooltip" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlTextSubtitle1", {
                    staticClass: "mr-4",
                    attrs: { text: "Action recommendations" }
                  }),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c("BlInputButton", {
                        attrs: { type: "outlined", dense: "", label: "Edit" },
                        on: { clicked: _vm.onOpenEditActionRecommendation }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "p-6 bg-white border rounded border-grey-200" },
                [
                  _c("div", { staticClass: "mb-4 space-y-1" }, [
                    _c(
                      "div",
                      { staticClass: "text-grey" },
                      [
                        _c("BlTextSubtitle2", {
                          attrs: { text: "Passing success metric" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text: "Updating the current target's status from"
                          }
                        }),
                        _vm._v(" "),
                        _c("StatusChip", {
                          attrs: { status: "in_progress", dense: "" }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "to" } }),
                        _vm._v(" "),
                        _c("StatusChip", {
                          attrs: { status: "mastered", dense: "" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.actionRecommendation.total_success === null &&
                  _vm.actionRecommendation.consecutive_success === null
                    ? _c(
                        "div",
                        [
                          _c("BlTextBody2", {
                            staticClass: "italic",
                            attrs: {
                              text:
                                "Currently, no action has been set for this recommendation."
                            }
                          })
                        ],
                        1
                      )
                    : _c("div", { staticClass: "pl-8 space-y-4" }, [
                        _vm.actionRecommendation.total_success !== null
                          ? _c("div", { staticClass: "space-y-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("BlTextSubtitle2", {
                                    staticClass: "text-sm text-grey",
                                    attrs: { text: "Total success" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-wrap items-center gap-1"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Receive a recommendation after completing"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "font-bold",
                                    attrs: {
                                      text:
                                        "at least " +
                                        _vm.actionRecommendation.total_success
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: { text: "successful session(s)." }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.actionRecommendation.consecutive_success !== null
                          ? _c("div", { staticClass: "space-y-1" }, [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-2" },
                                [
                                  _c("BlTextSubtitle2", {
                                    staticClass: "text-sm text-grey",
                                    attrs: { text: "Consecutive success" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-wrap items-center gap-1"
                                },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      text:
                                        "Receive a recommendation only if the session is successful for"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "font-bold",
                                    attrs: {
                                      text:
                                        _vm.actionRecommendation
                                          .consecutive_success +
                                        " consecutive session(s)."
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ])
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editActionRecommendationOpened
        ? _c("EditActionRecommendationsModal", {
            attrs: { actionRecommendation: _vm.actionRecommendation },
            on: {
              "close-modal": function($event) {
                _vm.editActionRecommendationOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Sbt")
        ? _c("div", { attrs: { id: "tasks" } }, [
            _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
            _vm._v(" "),
            _c("div", { staticClass: "p-6 space-y-4" }, [
              _c(
                "div",
                { staticClass: "flex items-center gap-4" },
                [
                  _c("BlTextSubtitle1", { attrs: { text: "Tasks" } }),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c("BlInputButton", {
                        attrs: {
                          type: "outlined",
                          dense: "",
                          label: "Edit task"
                        },
                        on: {
                          clicked: function($event) {
                            _vm.editTaskOpened = true
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "px-3 py-2" },
                _vm._l(_vm.target.target_tasks, function(item, i) {
                  return _c(
                    "div",
                    { key: item.id, staticClass: "flex items-center gap-3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center flex-shrink-0 w-2 h-2 text-sm font-medium rounded-full bg-slate-600"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "relative flex flex-col items-center justify-center"
                            },
                            [
                              i !== _vm.target.target_tasks.length - 1
                                ? _c("div", {
                                    staticClass:
                                      "absolute h-6 transform top-2 bg-slate-600",
                                    staticStyle: { width: "1px" }
                                  })
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex w-full gap-3 p-2 border-b " },
                        [
                          _c("BlTextBody2", {
                            staticClass:
                              "font-semibold truncate text-slate-1000",
                            attrs: { text: item.code + " - " + item.title }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editTaskOpened
        ? _c("EditTargetTaskDetailsModal", {
            attrs: { target: _vm.target, tasks: _vm.target.target_tasks },
            on: {
              "close-modal": function($event) {
                _vm.editTaskOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Sbt")
        ? _c("div", { attrs: { id: "prompt-sbt" } }, [
            _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
            _vm._v(" "),
            _c("div", { staticClass: "grid grid-cols-2 gap-6 p-6" }, [
              _c("div", [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4 mb-2" },
                  [
                    _c("BlTextSubtitle1", { attrs: { text: "Prompts" } }),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c("BlInputButton", {
                          attrs: { type: "outlined", dense: "", label: "Edit" },
                          on: { clicked: _vm.onOpenEditPromptSbt }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-center gap-2 mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "flex-shrink-0 w-20" },
                    [
                      _c("BlTextSubtitle2", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Score (%)" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "w-full " },
                    [
                      _c("BlTextSubtitle2", {
                        staticClass: "text-slate-700",
                        attrs: { text: "Prompt name" }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "space-y-16 mt-9" },
                  _vm._l(_vm.groupedSbtPrompts, function(prompt) {
                    return _c(
                      "div",
                      {
                        key: prompt.id,
                        staticClass: "flex items-center h-6 gap-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center w-20 h-20 rounded bg-prim-100"
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass:
                                "text-lg font-semibold text-light-purple",
                              attrs: { text: prompt.score }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          staticClass: "text-slate-1000",
                          attrs: { text: prompt.name }
                        })
                      ],
                      1
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex items-center justify-center border bg-grey-100 border-grey-200 rounded-3xl"
                },
                [
                  _c("SbtPromptingPreview", {
                    attrs: { prompts: _vm.sortedPromptsByPosition }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.editPromptSbtOpened
        ? _c("EditPromptsSbtModal", {
            attrs: {
              targetId: _vm.target.id,
              targetName: _vm.target.name,
              prompts: _vm.target.prompts
            },
            on: {
              "close-modal": function($event) {
                _vm.editPromptSbtOpened = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.target.type.includes("Sbt")
        ? _c(
            "div",
            { staticClass: "mt-8", attrs: { id: "problem-behavior" } },
            [
              _c("div", { staticClass: "w-full h-5 bg-grey-100" }),
              _vm._v(" "),
              _c("div", { staticClass: "p-6 space-y-4" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-4" },
                  [
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Problem behavior" }
                    }),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c("BlInputButton", {
                          attrs: { type: "outlined", dense: "", label: "Edit" },
                          on: {
                            clicked: function($event) {
                              _vm.editProblemBehaviorOpened = true
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "overflow-x-hidden rounded" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center flex-grow-0 w-full top-36 bg-slate-300"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4 rounded-tl",
                              style: { width: "10%" }
                            },
                            [
                              _c("BlTextSubtitle3", { attrs: { text: "Code" } })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4",
                              style: { width: "25%" }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: "Code definition" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4",
                              style: { width: "50%" }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: "Observed behaviors" }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center flex-shrink-0 h-12 px-4",
                              style: { width: "50%" }
                            },
                            [
                              _c("BlTextSubtitle3", {
                                attrs: { text: "Graph  color" }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.sortedProblemBehaviorsByPosition, function(
                        item
                      ) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass:
                              "flex items-center flex-grow-0 w-full border-b border-slate-400 bg-pure-white"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex flex-shrink-0 h-20 gap-2 px-4 py-3",
                                style: { width: "10%" },
                                attrs: { title: item.code }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass:
                                    "line-clamp-2 text-slate-1000 h-13",
                                  attrs: { text: item.code }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-shrink-0 h-20 px-4 py-3",
                                style: { width: "25%" }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass: "line-clamp-2 h-13",
                                  attrs: { text: item.code_definition }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-shrink-0 h-20 px-4 py-3",
                                style: { width: "50%" },
                                attrs: { title: item.description }
                              },
                              [
                                _c("BlTextBody1", {
                                  staticClass:
                                    "whitespace-pre-line line-clamp-2 h-13",
                                  attrs: { text: item.description || "-" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex-shrink-0 h-20 px-4 py-3",
                                style: { width: "50%" },
                                attrs: { title: item.color }
                              },
                              [
                                _c("div", {
                                  staticClass: "w-8 h-8 ml-6",
                                  style: { backgroundColor: item.color }
                                })
                              ]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editProblemBehaviorOpened
        ? _c("EditTargetBehaviorDetailsModal", {
            attrs: {
              target: _vm.target,
              targetProblemBehaviors: _vm.target.target_problem_behaviors
            },
            on: {
              "close-modal": function($event) {
                _vm.editProblemBehaviorOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63a85106", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a85106","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/PropertyDetails.vue
// module id = null
// module chunks = 